<template lang="pug">
#organization-owner-card.card.organization-owner-card.accordion-item.mb-1
  .d-flex.align-items-start.justify-content-between.gap-3
    .flex-grow-1
      .d-flex.justify-content-between.align-items-center.gap-2.organization-owner-card__header.mb-1
        .d-flex.align-items-center.gap-2.organization-owner-card__header.mb-1
          icon.organization-owner-card__icon(name='building')
          .d-flex.gap-2
            .d-flex.flex-column
              h6.organization-owner-card__title {{ organization.name }}
              p.organization-owner-card__meta.mb-1(
                v-if='organization.users_count !== undefined'
              )
                strong {{ organization.users_count }}
                |
                | {{ $t('modal.deleteAccountOrganizationsModal.card.usersCount') }}
        .d-flex.align-items-center.gap-2.organization-owner-card__header.mb-1
          info-pill.organization-owner-card__pill(
            :class='pillStateClass'
            :key='organization.id'
          )
            | {{ placeholderPill }}
          button.accordion-button(
            :aria-controls='`organization-card-collapse-${organization.id}`'
            :aria-expanded='index === 0'
            :class='{ collapsed: index !== 0 }'
            :data-bs-target='`#organization-card-collapse-${organization.id}`'
            data-bs-toggle='collapse'
            type='button'
          )
          label.form-check-label(
            :for='`organization-${organization.id}-transfer`'
          )
      .accordion-collapse.collapse(
        :aria-labelledby='`organization-card-heading-${organization.id}`'
        :class='{ show: index === 0 }'
        :id='`organization-card-collapse-${organization.id}`'
        data-bs-parent='#delete-account-organizations-owner-accordion'
      )
        .accordion-body
          .organization-owner-card__owners.mb-0
            strong.organization-owner-card__meta.organization-owner-card__owners-label
              | {{ $t('modal.deleteAccountOrganizationsModal.card.owners') }} ({{ this.ownersCount }})
            .organization-owner-card__meta__info.mb-0
              info-pill(
                :danger='owner.id === $root.user.id'
                :icon='owner.id === $root.user.id ? "xmark" : "user"'
                :key='owner.id'
                v-for='owner in ownersList'
              )
                | {{ owner.name }} - {{ owner.email }}
          .organization-owner-card__actions
            .form-check
              input.form-check-input(
                :checked='value === "delete"'
                :id='`organization-${organization.id}-delete`'
                :name='`organization-action-${organization.id}`'
                @change='selectDelete'
                type='radio'
              )
              label.form-check-label(
                :for='`organization-${organization.id}-delete`'
              )
                | {{ $t('modal.deleteAccountOrganizationsModal.card.deleteOrganization') }}
            p.organization-owner-card__alert(
              v-if='value === "delete" && hasOthersOwners'
            )
              | {{ $t('modal.deleteAccountOrganizationsModal.card.deleteOrganizationWarning') }}
            .organization-owner-card__alert(
              v-if='value === "delete" && !hasOthersOwners'
            )
              p.mb-2
                | {{ $t('modal.deleteAccountOrganizationsModal.card.deleteOrganizationWarningSingleUserPhrase1') }}
              p.mb-0
                | {{ $t('modal.deleteAccountOrganizationsModal.card.deleteOrganizationWarningSingleUserPhrase2') }}
            .form-check(v-if='nonOwnersCount > 0')
              input.form-check-input(
                :checked='value === "transfer"'
                :disabled='isDisabledTransfer'
                :id='`organization-${organization.id}-transfer`'
                :name='`organization-action-${organization.id}`'
                @change='selectTransfer'
                type='radio'
              )
              label.form-check-label(
                :for='`organization-${organization.id}-transfer`'
              )
                | {{ $t('modal.deleteAccountOrganizationsModal.card.transferOrganization') }}
                p.organization-owner-card__meta(v-if='isDisabledTransfer')
                  icon(name='circle-exclamation')
                  span.mb-0 {{ $t('modal.deleteAccountOrganizationsModal.card.isDisabledTransfer') }}
                div(v-if='value === "transfer" && !isDisabledTransfer')
                  aol-select(
                    :clearable='true'
                    :disabled='isDisabledSelect'
                    :options='optionsList'
                    :placeholder='placeholderSelect'
                    :reduce='(owner) => owner.id'
                    :value='selectedNewOwnerId'
                    @input='handleSelectNewOwner'
                    label='title'
                  )
                    template(v-slot:no-options='{}')
                      span.text {{ $t('modal.deleteAccountOrganizationsModal.card.noOptions') }}
                    template(v-slot:selected-option='{ title, icon }')
                      icon(:name='icon')
                      span.text {{ title }}
                    template(v-slot:option='{ title, icon }')
                      icon(:name='icon')
                      span.text {{ title }}
                    template(v-slot:prepend='{}')
                      icon(:name='icon') 
            .form-check.mb-2(v-if='ownersCount > 1')
              input.form-check-input(
                :checked='value === "leave"'
                :id='`organization-${organization.id}-leave`'
                :name='`organization-action-${organization.id}`'
                @change='$emit("input", "leave")'
                type='radio'
              )
              label.form-check-label(
                :for='`organization-${organization.id}-leave`'
              )
                | {{ $t('modal.deleteAccountOrganizationsModal.card.leaveOrganization') }}
            p.organization-owner-card__alert(v-if='value === "leave"')
              | {{ $t('modal.deleteAccountOrganizationsModal.card.leaveOrganizationOwnersInfo') }}
</template>
<script>
import UsersService from '@/services/UsersService';
import Icon from '@/ui/atoms/Icon.vue';
import InfoPill from '@/modules/business/components/molecules/InfoPill.vue';

export default {
  name: 'OrganizationOwnerCard',
  components: {
    InfoPill,
    Icon,
  },
  props: {
    organization: {
      type: Object,
      required: true,
    },
    value: {
      type: String,
      default: '',
    },
    selectedNewOwnerId: {
      type: String,
      default: '',
    },
    index: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      usersList: [],
      hasLoadedAllUsers: false,
      loadingUsers: false,
      action: '',
    };
  },
  watch: {
    value: {
      immediate: true,
      handler(newValue) {
        this.action = newValue;
      },
    },
  },
  mounted() {
    this.hasLoadedAllUsers = false;
    this.action = '';
    if (!this.hasLoadedAllUsers) {
      this.fetchAllUsers();
    }
  },
  computed: {
    ownersList() {
      return this.usersList.filter((user) => user.is_owner === true);
    },
    optionsList() {
      return this.usersList
        .filter((user) => user.id !== this.$root.user.id)
        .filter((user) => user.is_owner === false)
        .map((user) => ({
          id: user.id,
          title: `${user.name} - ${user.email}`,
          icon: 'user',
        }));
    },
    ownersCount() {
      return this.ownersList.length;
    },
    nonOwnersCount() {
      return this.usersList.filter((user) => user.is_owner === false).length;
    },
    hasOthersOwners() {
      return this.organization.users_count > 1 && this.usersList.length > 1;
    },
    isDisabledTransfer() {
      return this.organization.users_count <= 1;
    },
    isDisabledSelect() {
      return this.loadingUsers || this.optionsList.length === 0;
    },
    placeholderSelect() {
      return this.loadingUsers
        ? this.$t('modal.deleteAccountOrganizationsModal.card.loading')
        : this.$t('modal.deleteAccountOrganizationsModal.card.selectNewOwner');
    },
    placeholderPill() {
      switch (this.action) {
        case 'transfer':
          return this.$t(
            'modal.deleteAccountReviewActionsOrganizationsModal.card.transfer'
          );
        case 'delete':
          return this.$t(
            'modal.deleteAccountReviewActionsOrganizationsModal.card.delete'
          );
        case 'leave':
          return this.$t(
            'modal.deleteAccountReviewActionsOrganizationsModal.card.leave'
          );
        default:
          return this.$t(
            'modal.deleteAccountReviewActionsOrganizationsModal.card.default'
          );
      }
    },
    pillStateClass() {
      switch (this.action) {
        case 'transfer':
          return 'organization-owner-pill__owners-bg-transfer';
        case 'delete':
          return 'organization-owner-pill__owners-bg-delete';
        case 'leave':
          return 'organization-owner-pill__owners-bg-leave';
        default:
          return '';
      }
    },
  },
  methods: {
    submit() {
      const payload = this.organizationDecisions.map((decision) => {
        if (decision.action === 'leave') {
          return {
            ...decision,
            anonymize: false,
            change_owner: false,
            new_owner: null,
          };
        }
        return decision;
      });
      this.$emit('process', payload);
    },
    async fetchAllUsers() {
      if (this.hasLoadedAllUsers || this.loadingUsers) {
        return;
      }
      this.loadingUsers = true;

      try {
        let page = 1;
        let hasNextPage = true;
        let allUsers = [];

        while (hasNextPage) {
          const params = new URLSearchParams({ page });
          const response = await UsersService.listByOrganization(
            this.organization.id,
            params.toString()
          );
          allUsers = allUsers.concat(response.data.data || []);
          hasNextPage = Boolean(response.data.links?.next);
          page += 1;
        }

        this.usersList = allUsers;
        this.hasLoadedAllUsers = true;
      } finally {
        this.loadingUsers = false;
      }
    },
    handleSelectNewOwner(selectedId) {
      const selectedUser = this.usersList.find(
        (user) => user.id === selectedId
      );

      const newOwnerReviewData = selectedUser
        ? {
            id: selectedUser.id,
            name: selectedUser.name,
            email: selectedUser.email,
          }
        : null;

      this.$emit('select-new-owner', selectedId);
      this.$emit('select-new-owner-review-data', newOwnerReviewData);
    },
    async selectTransfer() {
      this.action = 'transfer';
      this.$emit('input', 'transfer');

      if (!this.hasLoadedAllUsers) {
        await this.fetchAllUsers();
      }
    },
    async selectDelete() {
      this.action = 'delete';
      this.$emit('input', 'delete');
    },
  },
};
</script>

<style scoped lang="stylus">
.organization-owner-card {
  text-align: left;
  border: 1px solid #cccccc;
  border-radius: 10px;
  padding: 16px;
  background: #ffffff;
}

.organization-owner-card__header {
  color: #013D52;
}

.organization-owner-card__title {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: inherit;
}

.organization-owner-card__icon {
  color: inherit;
  font-size: 32px;
  line-height: 1;
}

.organization-owner-card__meta {
  font-size: 14px;
  color: #013D52;
}

.organization-owner-card__owners {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  flex-wrap: wrap;
}

.organization-owner-card__owners-label {
  margin: 0;
  flex-shrink: 0;
}

.organization-owner-card__meta__info {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  font-size: 14px;
  color: #555;
  line-height: 0;
}

.organization-owner-card__actions {
  font-size: 18px;
  color: #555;
}

.organization-owner-card__alert {
  font-size: 14px;
  background-color: #FFF6E5;
  border: 1px solid #fff3cd;
  border-radius: 10px;
  padding: 16px;
  color: #013D52;
}

.organization-owner-pill__owners-bg-transfer {
  color: #013d52;
  background: #E0EFF2;
}

.organization-owner-pill__owners-bg-leave {
  color: #0f7d40;
  background: #E0EFF2;
}

.organization-owner-pill__owners-bg-delete {
  color: #d00a00;
  background: #F7E0DF;
}

.accordion-item .accordion-body
  border: none

.accordion-button
  background: #ffffff
  border: none
  border-radius: 10px
  padding: 12px 16px
  font-weight: 600
  font-size: 16px
  color: #013D52
  width: auto
  text-decoration: none

  &:not(.collapsed)
    background: #ffffff
    border-radius: 10px
    box-shadow: none

  &:focus
    outline: none
    box-shadow: none

  &::after
    background-image: url('../../../../../public/images/accordion-arrow.svg')
</style>
